import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import styled from "styled-components";
import InvitesChecklist from "src/scenes/teams/team/invites-checklist";
import TeamMemberAddModalAutocomplete from "src/scenes/teams/team/team-member-add-modal-autocomplete";

const SubTitle = styled.h2`
    font-size: 12px;
    font-weight: 300;
    padding: 12px;
    margin: 0;
    color: ${({ theme }) => theme.palette.secondary.main};
    max-width: 28rem;
`;

const steps = ["Select users to add", "Select users to invite"];

const AddInviteStepper = ({
    usersToAdd,
    setUsersToAdd,
    clearError,
    validationBlocker,
    handleSubmit,
    teamApi,
}) => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [addRegisteredOnly, setAddRegisteredOnly] = React.useState(false);

    React.useEffect(() => {
        const allRegistered = usersToAdd.every((user) => user.isRegistered === true);
        if (allRegistered) {
            setAddRegisteredOnly(true);
        } else setAddRegisteredOnly(false);
    }, [usersToAdd]);
    const handleNext = () => {
        if (activeStep === 1 || (activeStep === 0 && addRegisteredOnly)) setActiveStep(activeStep);
        const newActiveStep = activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const getButton = () => {
        if (activeStep === 0 && addRegisteredOnly) {
            return (
                <Button
                    variant="contained"
                    disabled={!usersToAdd || usersToAdd.length === 0 || validationBlocker}
                    onClick={handleSubmit}
                >
                    Add Users
                </Button>
            );
        }
        if (activeStep === 0 && !addRegisteredOnly) {
            return (
                <Button
                    onClick={handleNext}
                    disabled={!usersToAdd || usersToAdd.length === 0}
                    sx={{ mr: 1 }}
                >
                    Next
                </Button>
            );
        }
        if (activeStep === 1) {
            return (
                <Button
                    variant="contained"
                    disabled={!usersToAdd || usersToAdd.length === 0 || validationBlocker}
                    onClick={handleSubmit}
                >
                    Add Users
                </Button>
            );
        }
        return null;
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepButton
                            color="inherit"
                            disabled={index === 1 && addRegisteredOnly}
                            onClick={handleStep(index)}
                        >
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <div>
                {activeStep === 0 && (
                    <>
                        <SubTitle>
                            Add users within your organisation automatically to your team or invite
                            and add new users.
                        </SubTitle>
                        <TeamMemberAddModalAutocomplete
                            existingMembers={teamApi && teamApi.data && teamApi.data.members}
                            usersToAdd={usersToAdd}
                            setUsersToAdd={setUsersToAdd}
                            clearError={clearError}
                        />
                    </>
                )}
                {activeStep === 1 && (
                    <>
                        <SubTitle>Invite unregistered users to platform</SubTitle>
                        <InvitesChecklist usersToAdd={usersToAdd} setUsersToAdd={setUsersToAdd} />
                    </>
                )}
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                        color="inherit"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                    >
                        Back
                    </Button>
                    <Box sx={{ flex: "1 1 auto" }} />
                    {getButton()}
                </Box>
            </div>
        </Box>
    );
};
export default AddInviteStepper;
